/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext, useState } from 'react';
import { isEqual as isEqualTime } from 'date-fns';
import { UniversalSearchContext } from 'contexts';
import { featureEnabled, formatISODateStr } from 'utils';
import { useBreakpoint } from 'hooks';
import { StyledFooterButton } from '../StyledComponents';
import TourListingContext from '../TourListingContext';
import TourEditContext from '../TourEditContext';
import { TourModalType } from '../types';

const TourListingModalFooter: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const {
    modalType,
    setModalType,
    listing,
    setAppointmentId,
    selectedTourItem,
    setSelectedTourItem,
    selectedTimes,
    modalFromSearchBar,
    appointment,
    setListingModalState,
    mobileFooterRef,
  } = useContext(TourListingContext);
  const { setSearchOpenFromTour } = useContext(UniversalSearchContext);
  const {
    addSelectedListingToTour,
    appointmentTimeChange,
    removeItemFromTour,
  } = useContext(TourEditContext);

  const { lg } = useBreakpoint();
  const closeModal = () => {
    setLoading(false);
    setListingModalState(false);
    setAppointmentId('');
    setSelectedTourItem(null);
  };

  const onAddToTour = async () => {
    setLoading(true);
    await addSelectedListingToTour(listing.id);
    if (modalFromSearchBar) setSearchOpenFromTour(false);
    closeModal();
  };

  const onRemoveFromTour = async () => {
    setLoading(true);
    await removeItemFromTour(selectedTourItem.id);
    if (modalFromSearchBar) setSearchOpenFromTour(false);
    closeModal();
  };

  const onEditShowing = async () => {
    setModalType(TourModalType.APPOINTMENT);
    setAppointmentId(selectedTourItem.appointmentId);
    setListingModalState(true);
  };

  const onTimeChangeRequest = async () => {
    setLoading(true);
    const options = {
      date: formatISODateStr(selectedTimes[0], selectedTourItem.timezone),
      time: selectedTimes[0] as Date,
      timeEnd: selectedTimes[1] as Date,
      getUpdatedStatus: true,
    };
    await appointmentTimeChange(appointment.id, options);
    setAppointmentId('');
    if (modalFromSearchBar) setSearchOpenFromTour(false);
    closeModal();
  };

  let actionButtonLabel: string;
  let actionButtonFunc: (args: any) => Promise<void>;
  let dataCyLabel: string;
  let disabled = true;
  if (modalType === TourModalType.LISTING) {
    disabled = !listing?.id;

    if (!selectedTourItem) {
      dataCyLabel = 'add-to-tour-listing-modal';
      actionButtonLabel = 'Add to Tour';
      actionButtonFunc = onAddToTour;
    } else if (selectedTourItem.tourItemId) {
      dataCyLabel = 'remove-from-tour-listing-modal';
      actionButtonLabel = 'Remove from Tour';
      actionButtonFunc = onRemoveFromTour;
    } else if (selectedTourItem.appointmentId) {
      dataCyLabel = 'edit-tour-showing-listing-modal';
      actionButtonLabel = 'Edit Showing';
      actionButtonFunc = onEditShowing;
    }
  } else if (modalType === TourModalType.RESCHEDULE) {
    disabled =
      !appointment ||
      !selectedTourItem ||
      selectedTimes.includes(null) ||
      (isEqualTime(selectedTourItem.time, selectedTimes[0]) &&
        isEqualTime(selectedTourItem.timeEnd, selectedTimes[1]));
    dataCyLabel = 'edit-tour-request-reschedule-modal';
    actionButtonLabel = 'Send Request';
    actionButtonFunc = onTimeChangeRequest;
  }
  return (
    <div ref={mobileFooterRef}>
      {lg && (
        <StyledFooterButton
          data-cy="close-tour-listing-modal"
          onClick={() => closeModal()}
        >
          Close
        </StyledFooterButton>
      )}
      {actionButtonLabel && (
        <StyledFooterButton
          $isLgSize={!lg}
          type="primary"
          disabled={disabled || loading}
          loading={loading}
          onClick={actionButtonFunc}
          data-cy={dataCyLabel}
        >
          {actionButtonLabel}
        </StyledFooterButton>
      )}
    </div>
  );
};

export default TourListingModalFooter;
